var settings_default = {
	root: {
		"default-theme": "light",
		"default-sidebar": "right"
	},
	code: {
		"default-scheme": "highlight",
		"default-verbose": false,
		"default-indent-spaces": 2
	},
	renderer: {
		"default-positioning": "center",
		"default-background": "white"
	}
};
//#endregion
export { settings_default as default };

//# sourceMappingURL=settings.json.js.map